export function isPhoneLike() {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return false;
  }
  return (
    window.matchMedia('(max-width: 639px)').matches ||
    window.matchMedia('(hover: none) and (pointer: coarse)').matches
  );
}

export function prefersNativeCapture() {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return false;
  }
  return window.matchMedia('(hover: none) and (pointer: coarse)').matches;
}

export function pickDeviceFiles(
  opts: { accept?: string; capture?: 'user' | 'environment'; multiple?: boolean },
  onFiles: (files: File[]) => void,
  onCancel?: () => void,
) {
  const input = document.createElement('input');
  input.type = 'file';
  input.className = 'sr-only';
  input.tabIndex = -1;
  input.setAttribute('aria-hidden', 'true');
  if (opts.accept) {
    input.accept = opts.accept;
  }
  if (opts.capture) {
    input.setAttribute('capture', opts.capture);
  }
  input.multiple = !!opts.multiple;

  function cleanup() {
    input.remove();
  }
  input.addEventListener('change', () => {
    const files = Array.from(input.files || []);
    cleanup();
    if (files.length) {
      onFiles(files);
    } else {
      onCancel?.();
    }
  });
  input.addEventListener('cancel', () => {
    cleanup();
    onCancel?.();
  });
  document.body.appendChild(input);
  input.click();
}
